import api from './api.ts';

export type GoalMode = 'absolute' | 'percentage';
export type GoalCalculationBasis = 'revenue' | 'leads' | 'agendamentos' | 'comparecimentos' | 'vendas';
export type GoalPeriodType = 'monthly' | 'weekly' | 'daily';

export interface ClinicGoal {
  id: number;
  clinic_id: number;
  name: string;
  period_type: GoalPeriodType;
  start_date: string;
  end_date: string;
  mode: GoalMode;
  calculation_basis: GoalCalculationBasis;
  target_revenue?: number | null;
  target_leads?: number | null;
  target_agendamentos?: number | null;
  target_comparecimentos?: number | null;
  target_vendas?: number | null;
  target_percent_agendamentos?: number | null;
  target_percent_comparecimentos?: number | null;
  target_percent_vendas?: number | null;
  target_ticket_medio?: number | null;
  source_filter?: string | null;
  tag_ids: number[];
  active: boolean;
  created_at: string;
  updated_at: string;
}

export interface ClinicGoalPayload {
  name: string;
  period_type: GoalPeriodType;
  start_date: string;
  end_date: string;
  mode: GoalMode;
  calculation_basis: GoalCalculationBasis;
  target_revenue?: number | null;
  target_leads?: number | null;
  target_agendamentos?: number | null;
  target_comparecimentos?: number | null;
  target_vendas?: number | null;
  target_percent_agendamentos?: number | null;
  target_percent_comparecimentos?: number | null;
  target_percent_vendas?: number | null;
  target_ticket_medio?: number | null;
  source_filter?: string | null;
  tag_ids: number[];
  active?: boolean;
}

export interface ClinicGoalListFilters {
  activeOnly?: boolean;
  startDate?: string;
  endDate?: string;
}

export async function getClinicGoals(filters: ClinicGoalListFilters = {}): Promise<ClinicGoal[]> {
  const params = new URLSearchParams();
  params.append('active_only', String(filters.activeOnly ?? true));
  if (filters.startDate) params.append('start_date', filters.startDate);
  if (filters.endDate) params.append('end_date', filters.endDate);

  const url = `/api/goals?${params.toString()}`;
  console.log('[getClinicGoals] Buscando metas:', url);

  try {
    const response = await api.get<ClinicGoal[]>(url);
    console.log('[getClinicGoals] Metas recebidas:', response.data.length);
    return response.data;
  } catch (error) {
    console.error('[getClinicGoals] Erro ao buscar metas:', error);
    throw error;
  }
}

export async function createClinicGoal(payload: ClinicGoalPayload): Promise<ClinicGoal> {
  console.log('[createClinicGoal] Criando meta:', payload.name);

  try {
    const response = await api.post<ClinicGoal>('/api/goals', payload);
    console.log('[createClinicGoal] Meta criada:', response.data.id);
    return response.data;
  } catch (error) {
    console.error('[createClinicGoal] Erro ao criar meta:', error);
    throw error;
  }
}

export async function updateClinicGoal(goalId: number, payload: Partial<ClinicGoalPayload>): Promise<ClinicGoal> {
  console.log('[updateClinicGoal] Atualizando meta:', goalId);

  try {
    const response = await api.put<ClinicGoal>(`/api/goals/${goalId}`, payload);
    console.log('[updateClinicGoal] Meta atualizada:', response.data.id);
    return response.data;
  } catch (error) {
    console.error('[updateClinicGoal] Erro ao atualizar meta:', error);
    throw error;
  }
}

export async function deleteClinicGoal(goalId: number): Promise<void> {
  console.log('[deleteClinicGoal] Arquivando meta:', goalId);

  try {
    await api.delete(`/api/goals/${goalId}`);
    console.log('[deleteClinicGoal] Meta arquivada:', goalId);
  } catch (error) {
    console.error('[deleteClinicGoal] Erro ao arquivar meta:', error);
    throw error;
  }
}

export async function permanentlyDeleteClinicGoal(goalId: number): Promise<void> {
  console.log('[permanentlyDeleteClinicGoal] Excluindo meta arquivada:', goalId);

  try {
    await api.delete(`/api/goals/${goalId}/permanent`);
    console.log('[permanentlyDeleteClinicGoal] Meta arquivada excluída:', goalId);
  } catch (error) {
    console.error('[permanentlyDeleteClinicGoal] Erro ao excluir meta arquivada:', error);
    throw error;
  }
}
